import { useFirmViewMode } from './useFirmViewMode';

export const useIsDesktopView = () => {
  return useFirmViewMode().isDesktop;
};
